
'use strict'

import objectAssign from 'object-assign'

const setVideoEvents = (elem, classNames) => {
  elem.addEventListener('timeupdate', (event) => {
    let targetElem = event.currentTarget
    // console.log('timeupdate')

    if (
      targetElem.currentTime > 0.9 &&
      !targetElem.classList.contains(classNames.visible)
    ) {
      targetElem.classList.add(classNames.visible)
    }
  })
}

const bgVideo = (videoElem) => {
  return objectAssign({}, {

    init: function() {
      // Don't do anything if the video isn't visible at all
      if (videoElem.offsetHeight === 0) {
        console.log('video isnt visible at all')
        return
      }

      // console.log('video init')

      setVideoEvents(videoElem, {
        visible: 'is-visible'
      })

      videoElem.play()
    }

  })
}

export default bgVideo




/** WEBPACK FOOTER **
 ** ./src/scripts/client/components/bgVideo.js
 **/